import { InputGroup,Input,defineStyle,Box,Field,Spinner } from "@chakra-ui/react"


export default function InputC(props) {
  const { label,placeholder,loadingPin,isError,errorMsg,prefix } = props;

  return (
    <Field.Root gap={1} invalid={isError} color={"var(--crt-3)"}>
      <Field.Label >
        {label} {loadingPin ? <Spinner size="sm" ml={2} /> : null}
      </Field.Label>
      <InputGroup startAddon={prefix}>
        <Input
          {...props}
          size="sm"
          fontSize={"sm"}
          _placeholder={{ fontSize: "sm" }}
          placeholder={placeholder || label}
          borderRadius="md"
          bg="#fbfdfeff"
          _dark={{ bg: "#f5faffff" }}
          _hover={{ bg: "#f5faffff", _dark: { bg: "#f5faffff" } }}
          _focusVisible={{
            borderColor: "#bcf4ffff",
            boxShadow: "#1E93AB 0px 0px 2px 0px",
          }}
        />
      </InputGroup>
      {isError && <Field.ErrorText fontSize="sm" color={"red.500"}>{errorMsg?errorMsg:""}</Field.ErrorText>}
    </Field.Root>
    
    
  )
}

const floatingStyles = defineStyle({
  pos: "absolute",
  bg: "bg",
  px: "0.5",
  top: "-3",
  insetStart: "2",
  fontWeight: "normal",
  pointerEvents: "none",
  transition: "position",
  _peerPlaceholderShown: {
    color: "fg.muted",
    top: "2.5",
    insetStart: "3",
  },
  _peerFocusVisible: {
    color: "fg",
    top: "-3",
    insetStart: "2",
  },
})